//=include  ../dataLayer.js
import DataLayer from '../dataLayer'
import { CookieService } from '../../vue/services/CookieService';

export default class BookerTracker {


    constructor() {
        this.analytics = window.__pt.fn.analytics;
        this.settings = window.__pt.settings;
        this.events = window.__pt.fn.analytics.events;
        this.pages = window.__pt.fn.analytics.pages;
        this.fn = window.__pt.fn || {}
        this.site = window.__pt.settings.site || {};

    }

    metricBookerHotel(fn, arg) {
        try {
            const { data, vmData, element } = arg;

            const totalNights = this.countNight(data.checkin, data.checkout);

            // days_ahead: días desde hoy hasta el checkin
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const checkinDate = this.fn.getDate(data.checkin);
            const daysAhead = this.fn.diffBetweenDays(today, checkinDate);
            // deben enviarse "1,3,4" por ejemplo, dependiendo de las edades de los niños
            const childrenAges = (vmData.paxes?.children || []).map(c => c.year).join(',');

            const eventParams = {
                layer: "stays",
                field_date1: data.checkin,
                field_date2: data.checkout,
                field_rooms: vmData.paxes?.rooms ?? data.rooms,
                days_ahead: daysAhead,
                total_nights: totalNights,
                travelers_adults: vmData.paxes?.adults ?? data.adults,
                travelers_children: vmData.paxes?.children?.length ?? (data.infants + data.kids),
                travelers_children_ages: childrenAges,
                search_term: vmData.place_selected.uri || "",
                search_type: "stays",
                // results_count: TODO - viene de la respuesta del API de disponibilidad, no del booker
            };

            const objMetric = {
                event: `ga4.${this.events.trackEvent}`,
                eventName: this.events.search,
                eventParams
            };
            this.analytics.set(null, { eventParams: null });
            this.analytics.set(objMetric.event, objMetric);
        } catch (e) {
            console.log(e)
        }
       
    }

    metricBookerFlight(fn, arg) {
        try {
            const { data, vmData } = arg;


            const objMetric = {
                event: this.events.trackEvent,
                eventName: this.events.search,
                checkIn: data.startingFromDateTime,
                checkOut: data.returningFromDateTime,
                placeId_destination: vmData.place_selected_to.id,
                rooms: 1,
                typeFlight: (data.mode == 1) ? "redondo" : (data.mode == 0) ? "sencillo" : "",
                nameOrigin: vmData.place_selected.displayText,
                nights: this.countNight(data.startingFromDateTime, data.returningFromDateTime),
                adults: data.adults,
                layer: this.settings.page,
                children: data.kids,
                place_name_destination: vmData.place_selected_to.displayText,
                search_type: "vuelo",
            }

            this.analytics.set(objMetric.event, objMetric);
        } catch (e) {
            console.log(e);

        }
        
    }
    //Botón: Módificar Búsqueda en recomendación
    metricModifiedSearchRecomendation(content = "recomendacion") {
        const data = {
            event: this.events.trackEvent,
            eventName: this.events.selectContent,
            content_type: this.events.button,  
            element: `${content}::modificar_busqueda`,
            layer: this.events.hotels,    
            page_type: this.settings.page
        }
        this.analytics.set(this.events.trackEvent, data);
    }

    metricBookerExchangeFlights() {
    const data = {
        event: this.events.trackEvent,
        eventName: this.events.selectContent,
        content_type: this.events.button,
        element: `booker::intercambio_vuelos`,
        layer: this.events.home,
        channel_id: this.site.channel,
        page_type: this.settings.page
    };
    this.analytics.set(this.events.trackEvent, data);
}


    metricBookerPackage(fn, arg) {

        try {
            const { data, vmData } = arg;
            const objMetric = {
                event: this.events.trackEvent,
                eventName: this.events.search,
                field_date1: data.CheckIn,
                field_date2: data.CheckOut,
                field_destination: vmData.place_selected_to.placeId,
                field_rooms: data.rooms,
                field_total_nights: this.countNight(data.CheckIn, data.CheckOut),
                layer: this.settings.page,
                search_term: vmData.place_name,
                search_type: "hotel+vuelo",
                travelers_adults: data.adults,
                travelers_children: data.infants + data.kids
            }

            this.analytics.set(objMetric.event, objMetric);
        } catch (e) {
            console.log(e)
        }
        
    }

    metricRecentSearch(element) {

        const objMetric = {
            event: this.events.trackEvent,
            eventName: this.events.selectContent,
            layer: this.settings.page,
            content_type: this.events.link,
            element: `booker_recent_search:: ${element}`,
            page_type: this.settings.page
        }

        this.analytics.set(objMetric.event, objMetric);
    }

    availabilityCalendar(events) {
        let eventsLength = events.length;

        for (var i = 0; i < eventsLength; i++) {
            const event = events[i];
            const objMetric = {
                event: this.events.gtmEvent,
                eventName: this.events.gtmEvent,
                eventCategory: "calendar no dispo",
                eventAction: event.action,
                eventLabel: event.label,
                eventExtra: ''
            }
            this.analytics.set(objMetric.event, objMetric);
        }
    }

    countNight(checkInStr, checkOutStr) {
        let checkIn = this.fn.getDate(checkInStr);
        let checkOut = this.fn.getDate(checkOutStr);
        let days = this.fn.diffBetweenDays(checkIn, checkOut);

        return days;
    };

    metricDatesRecommended(eventName, arg) {
        const { data } = arg;

        const paramsBySite = {
            event: this.events.trackEvent,
            eventName: eventName,
            hotelId: data.hotelId,
            checkIn: data.checkIn,
            checkOut: data.checkOut,
            nights: this.countNight(data.checkin, data.checkout),
            adults: data.adults,
            children: data.children,
            layer: this.settings.page,
            search_type: "hotel"
        }

        const objMetric = {...paramsBySite};

        this.analytics.set(objMetric.event, objMetric);
    }

    metricAutocompleteFlight(query, respDataArray = [], list = 'from') {
        try {
            const inputId = list === 'from' ? 'autocomplete_origin' : 'autocomplete_destination';
            const sourceItems = Array.isArray(respDataArray) ? respDataArray : [];

            const toAnalyticsItem = (it) => ({
                item_id: it?.code || "",
                item_name: it?.displayText || "",
                index: it?.positions,
                item_category: it?.placeType,
                item_list_id: inputId,
                item_list_name: inputId
            });

            // Aplanar resultados principales + airports al mismo nivel
            const flattenedItems = sourceItems.flatMap((it) => {
                const airports = Array.isArray(it?.airports) ? it.airports : [];
                return [it, ...airports];
            });

            const basePayload = {
                event: this.events.trackEvent,
                layer: "flights",
                search_term: query
            };

            // Evento: search_autocomplete
            this.analytics.set(this.events.trackEvent, {
                ...basePayload,
                eventName: "search_autocomplete",
                input_id: inputId,
                results_count: sourceItems.length
            });

            this.analytics.set(null, { ecommerce: null, items: null });

            // Evento: view_item_list (solo si hay resultados)
            if (flattenedItems.length > 0) {
                this.analytics.set(this.events.trackEvent, {
                    ...basePayload,
                    eventName: "view_item_list",
                    ecommerce: {
                        items: flattenedItems.map(toAnalyticsItem)
                    }
                });
            }

        } catch (e) {
            console.error("metricAutocompleteFlight Error:", e);
        }
    }
    metricAutocompleteFlightSelect(item, lastQuery, type = 'from',sufix='') {
        try {
            const inputId = type === 'from' ? 'autocomplete_origin' : 'autocomplete_destination';
            const event = {
                event: this.events.trackEvent,
                eventName: "select_item",
                layer: "flights",
                search_term: lastQuery,
                ecommerce: {
                    items: [
                        {
                            item_id: item.code || "",
                            item_name: item.displayText || "",
                            index: item.positions,
                            item_category: item.placeType,
                            item_list_id: inputId + sufix,
                            item_list_name: inputId + sufix
                        }
                    ]
                }
            };
            this.analytics.set(null, { ecommerce: null, items: null });
            this.analytics.set(this.events.trackEvent, event);

        } catch (e) {
            console.error("metricAutocompleteFlightSelect Error:", e);
        }
    }

    metricAutocompletePackageShown(query, items = [], list = 'from') {
        try {
            const inputId = list === 'from' ? 'autocomplete_origin' : 'autocomplete_destination';

            // Evento: search_autocomplete
            this.analytics.set(this.events.trackEvent, {
                event: this.events.trackEvent,
                eventName: "search_autocomplete",
                search_term: query,
                layer: "packages",
                input_id: inputId,
                results_count: items.length
            });

            this.analytics.set(null, { ecommerce: null, items: null });

            // Evento: view_item_list (solo si hay resultados)
            if (items.length > 0) {
                this.analytics.set(this.events.trackEvent, {
                    event: this.events.trackEvent,
                    eventName: "view_item_list",
                    layer: "packages",
                    search_term: query,
                    ecommerce: {
                        items: items.map((it, i) => ({
                            item_id: it.placeCode + "|" + it.placeId,
                            item_name: it.placeDescription,
                            index: it.positions,
                            item_category: it.placeType,
                            item_list_id: inputId,
                            item_list_name: inputId
                        }))
                    }
                });
            }

        } catch (e) {
            console.error("metricAutocompletePackageShown Error:", e);
        }
    }

    metricAutocompletePackageNoResults(query, list = 'from') {
        try {
            const inputId = list === 'from' ? 'autocomplete_origin' : 'autocomplete_destination';

            this.analytics.set(this.events.trackEvent, {
                event: this.events.trackEvent,
                eventName: "search_autocomplete",
                search_term: query,
                layer: "packages",
                input_id: inputId,
            });

        } catch (e) {
            console.error("metricAutocompletePackageNoResults Error:", e);
        }
    }

    metricAutocompletePackageSelect(item, lastQuery, type = 'from',sufix = '') {
        try {
            const inputId = type === 'from' ? 'autocomplete_origin' : 'autocomplete_destination';

            const event = {
                event: this.events.trackEvent,
                eventName: "select_item",
                layer: "packages",
                search_term: lastQuery,
                ecommerce: {
                    items: [
                        {
                            item_id: item.placeCode + "|" + item.placeId,
                            item_name: item.placeDescription || "",
                            index: item.positions,
                            item_category: item.placeType,
                            item_list_id: inputId + sufix,
                            item_list_name: inputId + sufix
                        }
                    ]
                }
            };
            this.analytics.set(null, { ecommerce: null, items: null });
            this.analytics.set(this.events.trackEvent, event);

        } catch (e) {
            console.error("metricAutocompletePackageSelect Error:", e);
        }
    }

    metricAutocompleteHotel(query, respDataArray = [], inputId = 'autocomplete_destination') {
        try {
            // Evento: search_autocomplete
            this.analytics.set(this.events.trackEvent, {
                event: this.events.trackEvent,
                eventName: "search_autocomplete",
                search_term: query,
                layer: "stays",
                input_id: inputId,
                results_count: respDataArray.length
            });

            this.analytics.set(null, { ecommerce: null, items: null });

            // Evento: view_item_list (solo si hay resultados)
            if (respDataArray.length > 0) {
                this.analytics.set(this.events.trackEvent, {
                    event: this.events.trackEvent,
                    eventName: "view_item_list",
                    layer: "stays",
                    search_term: query,
                    ecommerce: {
                        items: respDataArray.map((it, i) => ({
                            item_id: it.id || "",
                            item_name: it.displayText || "",
                            index: it.positions,
                            item_category: it.type,
                            item_list_id: inputId,
                            item_list_name: inputId
                        }))
                    }
                });
            }

        } catch (e) {
            console.error("metricAutocompleteHotel Error:", e);
        }
    }
    metricAutocompleteHotelSelect(item, lastQuery, inputId = 'autocomplete_destination', sufix = '') {
        try {
            const event = {
                event: this.events.trackEvent,
                eventName: "select_item",
                layer: "stays",
                search_term: lastQuery,
                ecommerce: {
                    items: [
                        {
                            item_id: item.id || "",
                            item_name: item.displayText || "",
                            index: item.positions,
                            item_category: item.type || "",
                            item_list_id: inputId + sufix,
                            item_list_name: inputId + sufix
                        }
                    ]
                }
            };

            this.analytics.set(null, { ecommerce: null, items: null });
            this.analytics.set(this.events.trackEvent, event);

        } catch (e) {
            console.error("metricAutocompleteHotelSelect Error:", e);
        }
    }

    metricConvertHotelSelect(hotel,filters, site,settings) {
        try {
            this.analytics.set(null, { ecommerce: null, items: null });

            const event = {
                event: this.events.trackEvent,
                eventName: "search_converted",
                search_session_id: CookieService.getCookie('session_id'),
                search_term_at_conversion: `${hotel.location.city}, ${hotel.location.state}, ${hotel.location.country}`,
                clicked_result_type: "destination",
                clicked_result_name: `${hotel.location.city}, ${hotel.location.state}, ${hotel.location.country}`,
                conversion_type: "hotel_booking",
                value: filters,
                currency: site.currencyCodeName,
                layer: settings?.page || "hotel_summary"
            };

            
            this.analytics.set(this.events.trackEvent, event);
        } catch (e) {
            console.error("metricConvertHotelSelect Error:", e);
        }
    }



}
